import React, {useEffect, useState} from 'react';
import {Parameter} from '../../Core/mobx/ParameterStore/ParameterStore';
import {observer} from 'mobx-react-lite';
import {makeStyles} from '@material-ui/core/styles';
import {labelTextStyle, TextBox} from '../../Core/UI';
import Utils from '../../Core/Utils';
import {Box, Grid, TextField, Tooltip, Typography} from '@material-ui/core';
import {Approval} from '../../Core/mobx/ParameterStore/Approval';
import {Prequal} from '../../Core/mobx/ParameterStore/Prequal';
import {FormType} from '../PreQualification/types';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

type HeightWeightProps = {
    parameters: Approval | Prequal;
    valueChanged:
        | ((p?: Parameter & {name?: string}, value?: any) => void)
        | ((p: Parameter, value: any, formType?: FormType) => void);
    preapproval?: boolean;
    prequal?: boolean;
};

const useStyles = makeStyles({
    formControl: {
        marginTop: 8,
        width: '100%',
    },
    tooltip: {
        maxWidth: 1000,
        width: '100%',
        background: '#fff',
        border: '1px solid gray',
    },
    separatedLabel: {
        display: 'inline-flex',
        marginBottom: 42,
    },
});

const BMITooltipContent = () => {
    return (
        <div>
            <img src="/img/lsw-build-chart.png" alt="Chart" style={{maxWidth: 1000, width: '100%', height: 'auto'}} />
        </div>
    );
};

const BMITooltipContentForSpecialProducts = () => {
    return (
        <div>
            <img src={'/img/build-chart-2.png'} alt="Chart" style={{maxWidth: 1000, width: '100%', height: 'auto'}} />
        </div>
    );
};

const HeightWeight = observer(({parameters, valueChanged, preapproval, prequal}: HeightWeightProps) => {
    const classes = useStyles();
    const [paramValue, setParamValue] = useState('');
    const [bmi, setBMI] = useState(0);

    const required = (value?: string) => (
        <span>
            {value && value} <span style={{color: 'red'}}>*</span>
        </span>
    );

    useEffect(() => {
        const value = Utils.Inch2Height(parameters.height?.value);
        setParamValue(value);
    }, [parameters.height?.value]);

    useEffect(() => {
        if (
            parameters.height?.value != null &&
            parameters.height?.value != 0 &&
            parameters.weight.value != null &&
            parameters.weight.value != 0
        ) {
            const bmi = (parameters.weight?.value / (parameters.height?.value * parameters.height?.value)) * 703;

            setBMI(Math.round(bmi * 100) / 100);
        } else {
            setBMI(0);
        }
    }, [parameters.height?.value, parameters.weight?.value]);

    return (
        <>
            <Grid item xs={preapproval ? 2 : 4}>
                {prequal && (
                    <Typography className={classes.separatedLabel} style={labelTextStyle}>
                        <span>{required('')}</span>
                        <span>Height (ft/in)</span>
                    </Typography>
                )}
                <TextField
                    id={'height'}
                    label={!prequal && required('Body Height (ft/in)')}
                    value={paramValue}
                    onBlur={(e) => {
                        const value = Utils.Height2Inch(e.target.value);
                        setParamValue(Utils.Inch2Height(value));
                        valueChanged({...parameters.height, name: 'height'}, value);
                    }}
                    onChange={(e) => setParamValue(e.target.value)}
                    className={classes.formControl}
                    variant="outlined"
                />
            </Grid>
            <Grid item xs={preapproval ? 2 : 4}>
                {prequal && (
                    <Typography className={classes.separatedLabel} style={labelTextStyle}>
                        <span>{required('')}</span>
                        <span>Weight (lbs)</span>
                    </Typography>
                )}
                <TextBox
                    id={'weight'}
                    label={!prequal && required('Body Weight (lbs)')}
                    type="number"
                    value={parameters.weight?.value}
                    onChange={(value) => valueChanged({...parameters.weight, name: 'weight'}, value)}
                />
            </Grid>
            <Grid item xs={preapproval ? 2 : 4}>
                {prequal && (
                    <Typography className={classes.separatedLabel} style={labelTextStyle}>
                        <span>{required('')}</span>
                        <span>BMI</span>
                    </Typography>
                )}
                <Box style={{display: 'flex', flexDirection: 'row'}}>
                    <TextBox
                        id={'weight'}
                        label={!prequal && 'BMI'}
                        type="number"
                        value={bmi}
                        disabled={true}
                        helperText={bmi >= 40 ? 'BMI is over 40. Submit to F&G Pathsetter.' : ''}
                    />
                    <Tooltip
                        arrow
                        leaveDelay={200}
                        placement="left"
                        classes={{tooltip: classes.tooltip}}
                        title={
                            parameters instanceof Prequal ||
                            (parameters instanceof Approval &&
                                parameters.agentProducts?.value.includes('FGPathsetterIUL')) ||
                            parameters.agentProducts?.value.includes('FGEverlast') ||
                            parameters.agentProducts?.value.includes('Prosper') ? (
                                <BMITooltipContentForSpecialProducts />
                            ) : (
                                <BMITooltipContent />
                            )
                        }
                    >
                        <InfoOutlinedIcon color="primary" />
                    </Tooltip>
                </Box>
            </Grid>
        </>
    );
});

export default HeightWeight;
